import React, { useEffect, useRef } from "react";
//import L from "leaflet";
//import 'leaflet/dist/leaflet.css';

import NEXUS_CONST from '../../common/constants'

import { connect, useSelector } from 'react-redux';

const style = {
    width: "100%",
    height: "100vh"
};


function SiteMap({ markersData, zoomMarker, activeTheme, sbg, zoomSiteInfo }) {
    const themeState = useSelector(state => state.theme.lightMode)

    // L.HtmlIcon = L.Icon.extend({

    //     initialize: function (options) {
    //         L.Util.setOptions(this, options);
    //     },
    //     createIcon: function () {
    //         var div = document.createElement('div');
    //         div.innerHTML = this.options.html;
    //         return div;
    //     },
    //     createShadow: function () {
    //         return null;
    //     }
    // });

    // const yelloIcon = L.HtmlIcon.extend({
    //     options: {
    //         html: '<div class="map__marker" style="background: #FFC627;"></div>',
    //     }
    // });

    // const RedIcon = L.HtmlIcon.extend({
    //     options: {
    //         html: '<div class="map__marker" style="background: #FF4433;"></div>',
    //     }
    // });

    // const GreenIcon = L.HtmlIcon.extend({
    //     options: {
    //         html: '<div class="green_marker" style="background: #00FF00;"><i class="fas fa-map-marker-alt" style="font-size: large;color: #00FF00;"></i></div>'
    //     }
    // });

    // const BlueIcon =  L.HtmlIcon.extend({
    //     options: {
    //         html: '<div class="map__marker_b" style="background: #4169E1;"></div>'
    //     }
    // });

    // const VisitedIcon = L.HtmlIcon.extend({
    //     options: {
    //         html: '<div class="map__marker" style="background: #8c8cff;"></div>'
    //     }
    // });

    // const yellowHtmlIcon = new yelloIcon();
    // const redIcon = new RedIcon();
    // const greenIcon = new GreenIcon();
    // const blueIcon = new BlueIcon();
    // const visitedIcon = new VisitedIcon();



    // const getMapUrl = () => {
  
    //     let mapUrl = "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png";

    //     if (themeState) {
    //         mapUrl = "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png";

    //     }

    //     return mapUrl;
    // }

    // // create map
    // const mapRef = useRef(null);
    // let tileLayer = L.tileLayer(getMapUrl(), {

    //     attribution: false
    // });

    // useEffect(() => {

        

    //     mapRef.current = L.map("map", {
    //         center: [25.291777468544872, 10.768948434906198],
    //         zoom: 2,
    //         dragging: true,
    //         scrollWheelZoom: true,
    //         zoomControl: true,
    //         zoomSnap: 0.1,
    //         minZoom: 2,
    //         maxZoom: 16,
    //         layers: [tileLayer]
    //     });
    // }, []);

    // // add layer
    // const layerRef = useRef(null);
    // useEffect(() => {
    //     layerRef.current = L.layerGroup().addTo(mapRef.current);
    // }, []);

    // const navHandler = (marker) => {
    //     return `<a href="/sitehome/${sbg}/${marker.siteId}">${marker.title} (${marker.siteId})</a>`
    // }


    // // update markers
    // useEffect(
    //     () => {
    //         layerRef.current.clearLayers();
    //         markersData.forEach(marker => {
       
    //             let iconColor = yellowHtmlIcon;
    //             if (marker.deployStatus === NEXUS_CONST.RED) {
    //                 iconColor = blueIcon 
                    
    //             }
    //             if (marker.deployStatus === NEXUS_CONST.GREEN) {
    //                 iconColor = greenIcon 
    //             }
    //             L.marker(marker.latLng, { icon: iconColor  }).bindPopup(navHandler(marker)).addTo(
    //                 layerRef.current
    //             );
    //         });


    //     },
    //     [markersData]
    // );

    // // zoom markers
    // useEffect(
    //     () => {
    //         if (zoomMarker) {
    //             mapRef.current.flyTo(zoomMarker, 4); 
    //             let iconColor = yellowHtmlIcon;
    //             if (zoomSiteInfo.deployStatus === NEXUS_CONST.RED) {
    //                 iconColor = blueIcon
    //             }
    //             if (zoomSiteInfo.deployStatus === NEXUS_CONST.GREEN) {
    //                 iconColor = greenIcon
    //             }
    //             let navHndlr = (marker) => {
    //                 return `<a href="/sitehome/${sbg}/${marker.siteId}">${marker.siteName} (${marker.siteId})</a>`
    //             }
    //             let markerRef = L.marker(zoomMarker, { icon: iconColor }).bindPopup(navHndlr(zoomSiteInfo)).addTo(
    //                 layerRef.current
    //             );
    //             markerRef.openPopup();
    //         }
    //         else
    //             mapRef.current.flyTo([25.291777468544872, 10.768948434906198], 2)
    //     },
    //     [zoomMarker]
    // );

    // useEffect(() => {
    //     if (mapRef.current) {

    //         tileLayer.setUrl(getMapUrl()).addTo(mapRef.current)
            
    //     }
      
    // }, [themeState])

   


    // return <div id="map" style={style} />;
}

//function mapStateToProps(state) {
//    const { base } = state
//    return { activeTheme: base.activeTheme }
//}

//export default connect(mapStateToProps)(SiteMap);
export default SiteMap;
